import { HttpService, ThreatsProvider, ThreatsService } from "@sportal/api";

export const makeThreatsService = (
  http: HttpService,
  backendUrl: string
): ThreatsService => new ThreatsService(new ThreatsProvider(http, backendUrl));
